module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vdige12-c1ea8c8237dd400bfe5d0951f1fd5ddb.jpg";